import { Link } from "react-router-dom";
import { MapPin, Mail, Phone } from "lucide-react";
import { useSettings } from "../../lib/useSettings";

export default function Footer() {
  const s = useSettings();
  return (
    <footer data-testid="site-footer" className="bg-[#0F1A14] text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 md:py-20">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-5">
            <img src="/assets/logo-betelgez.png" alt={s.company_name || "Betelgez Srl"} className="h-20 md:h-24 w-auto bg-white rounded-xl p-3 inline-block shadow-lg" />
            <p className="mt-6 text-white/70 leading-relaxed max-w-md">{s.tagline || ""}</p>
            <div className="mt-8 space-y-3 text-sm text-white/80">
              <div className="flex items-start gap-3"><MapPin className="w-4 h-4 mt-0.5 text-[#00A651]" /> {s.address}</div>
              <div className="flex items-center gap-3"><Mail className="w-4 h-4 text-[#00A651]" /> {s.email}</div>
              <div className="flex items-center gap-3"><Phone className="w-4 h-4 text-[#00A651]" /> {s.phone}</div>
            </div>
          </div>
          <div className="md:col-span-3">
            <h4 className="font-display font-semibold text-sm uppercase tracking-[0.2em] text-[#A7E2C0]">Navigazione</h4>
            <ul className="mt-5 space-y-3 text-sm text-white/80">
              <li><Link to="/" className="hover:text-white">Home</Link></li>
              <li><Link to="/chi-siamo" className="hover:text-white">Chi Siamo</Link></li>
              <li><Link to="/consulenza-imprese-agricole-sardegna" className="hover:text-white">Consulenza Aziendale</Link></li>
              <li><Link to="/servizi" className="hover:text-white">Servizi</Link></li>
              <li><Link to="/progetti" className="hover:text-white">Progetti</Link></li>
              <li><Link to="/contatti" className="hover:text-white">Contatti</Link></li>
            </ul>
          </div>
          <div className="md:col-span-4">
            <h4 className="font-display font-semibold text-sm uppercase tracking-[0.2em] text-[#A7E2C0]">Dati Societari</h4>
            <ul className="mt-5 space-y-2 text-sm text-white/80">
              <li>{s.company_name}</li>
              <li>Partita IVA {s.vat}</li>
              <li>PEC: {s.pec}</li>
            </ul>
            <h4 className="mt-8 font-display font-semibold text-sm uppercase tracking-[0.2em] text-[#A7E2C0]">Legale</h4>
            <ul className="mt-4 space-y-2 text-sm text-white/80">
              <li><Link to="/privacy" className="hover:text-white">Privacy Policy</Link></li>
              <li><Link to="/cookie" className="hover:text-white">Cookie Policy</Link></li>
            </ul>
          </div>
        </div>
        <div className="mt-14 pt-8 border-t border-white/10 flex flex-col sm:flex-row justify-between gap-4 text-xs text-white/50">
          <div>{s.footer_legal}</div>
          <Link to="/admin/login" className="hover:text-white/80" data-testid="footer-admin-link">Area Riservata</Link>
        </div>
      </div>
    </footer>
  );
}
